
import Vue from "vue";
import { Component } from "vue-property-decorator";
import MainLayout from "@/components/layout/Main.vue";

@Component({
    components: {
        MainLayout
    }
})
export default class App extends Vue {}
